import { useFragment } from "react-relay"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"
import { PatientContextAppointmentFragment$key } from "@/modules/patients/services/__generated__/PatientContextAppointmentFragment.graphql"
import { PatientContextAppointmentFragment } from "@/modules/patients/services/PatientContextAppointmentFragment"
import { usePatientByIdQuery } from "@/modules/patients/services/usePatientByIdQuery"

const useContextAppointment = () => {
  const patientId = usePatientParam()
  const countryCode = useCountryParam()
  const appointmentId = useAppointmentParam()

  const [patientData] = usePatientByIdQuery(patientId, countryCode, appointmentId)
  const contextAppointmentRef = appointmentId ? patientData.patientById?.contextAppointment : null

  const contextAppointment = useFragment<PatientContextAppointmentFragment$key>(
    PatientContextAppointmentFragment,
    contextAppointmentRef,
  )

  return contextAppointment
}

export { useContextAppointment }
